/* @generated */

// src/assets/ui-icon/line/location.tsx
import * as React from "react";
var LocationLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M10 10c0-1.346.654-2 2-2s2 .654 2 2-.654 2-2 2-2-.654-2-2Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.857 11.41c-.433 2.102-1.769 3.87-3.175 5.493L12 20a45.25 45.25 0 0 1-1.03-1.103 90.853 90.853 0 0 1-2.017-2.316c-1.18-1.398-2.245-2.931-2.7-4.704C6.104 11.304 6 10.704 6 10.154 6 6.013 7.963 4 12 4s6 2.013 6 6.154c0 .401-.056.83-.143 1.255ZM7.5 10.153c0-1.86.442-2.949 1.06-3.583.61-.625 1.651-1.07 3.44-1.07s2.83.445 3.44 1.071c.618.634 1.06 1.724 1.06 3.583 0 .27-.038.592-.113.953-.348 1.692-1.445 3.205-2.838 4.814l-1.589 1.834a91.632 91.632 0 0 1-1.861-2.141c-1.136-1.346-2.023-2.67-2.394-4.11-.13-.508-.205-.974-.205-1.35Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  LocationLine
};
